import React from 'react'
import { get } from 'lodash'
import { Doughnut, Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { getFloorAndItsElevationsStats } from '../../../../../helper/StatsHelper';

const SingleFloorsStats = (props) => {
    const { selectedFloorid, activityMode, commons } = props;
    const { floorsAndElevations, markerCount } = props.snagDetail;

    // preprocess the data
    const { fullTotal, fullActive, fullDefects, fullElevations, fullComplete, percentageFullComplete, } = getFloorAndItsElevationsStats(selectedFloorid, floorsAndElevations, markerCount);

    // calculate the numbers
    var allTotalMarkers = fullTotal;
    var allActiveMarkers = fullActive;
    var allDefectMarkers = fullDefects;
    var allElevationMarkers = fullElevations;
    var allCompletedMarkers = fullComplete;

    const labelsToShow = activityMode ? ['Completed', 'Ongoing'] : [`${commons.udefectMarkers}`, 'Elevations']
    const dataToShow = activityMode ? [allCompletedMarkers, allActiveMarkers] : [allDefectMarkers, allElevationMarkers]

    const data = {
        labels: labelsToShow,
        datasets: [
            {
                label: '',
                data: dataToShow,
                backgroundColor: [
                    'rgba(20, 56, 150, 0.4)',
                    'rgba(171, 169, 187, 0.4)',
                ],
                borderColor: [
                    'rgba(20, 56, 150, 1)',
                    'rgba(171, 169, 187 1)',
                ],
                borderWidth: 1,
            },
        ],
    }

    const options = {
        legend: {
            display: false
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    }

    const graphToPlot = activityMode ? <Bar data={data} height={120} options={options} /> : <Doughnut data={data} height={120} />;
    return (
        <React.Fragment>{graphToPlot}</React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commons: state.commons,
    }
}


export default connect(mapStateToProps)(SingleFloorsStats)
